/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplicationQuestionResponse,
    ApplicationQuestionResponseFromJSON,
    ApplicationQuestionResponseFromJSONTyped,
    ApplicationQuestionResponseToJSON,
    Attachment,
    AttachmentFromJSON,
    AttachmentFromJSONTyped,
    AttachmentToJSON,
    EducationResponse,
    EducationResponseFromJSON,
    EducationResponseFromJSONTyped,
    EducationResponseToJSON,
    EmploymentHistoryResponse,
    EmploymentHistoryResponseFromJSON,
    EmploymentHistoryResponseFromJSONTyped,
    EmploymentHistoryResponseToJSON,
    LanguageMaterialResponse,
    LanguageMaterialResponseFromJSON,
    LanguageMaterialResponseFromJSONTyped,
    LanguageMaterialResponseToJSON,
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
    ResponseToApplicant,
    ResponseToApplicantFromJSON,
    ResponseToApplicantFromJSONTyped,
    ResponseToApplicantToJSON,
    ScholarshipResponse,
    ScholarshipResponseFromJSON,
    ScholarshipResponseFromJSONTyped,
    ScholarshipResponseToJSON,
    ScreenTypeOption,
    ScreenTypeOptionFromJSON,
    ScreenTypeOptionFromJSONTyped,
    ScreenTypeOptionToJSON,
    SupplementalMaterialResponse,
    SupplementalMaterialResponseFromJSON,
    SupplementalMaterialResponseFromJSONTyped,
    SupplementalMaterialResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApplicationResponse
 */
export interface ApplicationResponse {
    /**
     * 
     * @type {number}
     * @memberof ApplicationResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationResponse
     */
    applicantId: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationResponse
     */
    binderId: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    state: ApplicationResponseStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    reentry: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    resubmit: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    duplicated?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationResponse
     */
    sentAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationResponse
     */
    firstSentAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationResponse
     */
    repliedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    aaoNote?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    idCardNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    readManual?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    familyName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    familyNameInChinese?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    middleNameInChinese?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    givenNameInChinese?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    gender?: ApplicationResponseGenderEnum;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationResponse
     */
    birthdate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    otherNationality?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    primaryPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    secondaryPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    currentAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    currentStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    supervisor?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    researchTopic?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    gpa1?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    gpa2?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    otherProgram?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    programPreferredLanguage?: ApplicationResponseProgramPreferredLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    screenTypeEnOther?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    screenTypeJaOther?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    japaneseHaveStudied?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    haveWorkedFullTime?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationResponse
     */
    japaneseStudyFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationResponse
     */
    japaneseStudyTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    japaneseStudyMethod?: string;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationResponse
     */
    anticipatedEnrollmentDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ApplicationResponse
     */
    anticipatedEnrollmentYear?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationResponse
     */
    anticipatedEnrollmentDateOfMonth?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    language?: ApplicationResponseLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponse
     */
    notes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponse
     */
    isAgreePrivacyNotice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApplicationResponse
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {ResponseToApplicant}
     * @memberof ApplicationResponse
     */
    acceptResponse?: ResponseToApplicant;
    /**
     * 
     * @type {ResponseToApplicant}
     * @memberof ApplicationResponse
     */
    returnResponse?: ResponseToApplicant;
    /**
     * 
     * @type {Array<EducationResponse>}
     * @memberof ApplicationResponse
     */
    educations: Array<EducationResponse>;
    /**
     * 
     * @type {Array<ScholarshipResponse>}
     * @memberof ApplicationResponse
     */
    scholarships: Array<ScholarshipResponse>;
    /**
     * 
     * @type {Array<SupplementalMaterialResponse>}
     * @memberof ApplicationResponse
     */
    supplementalMaterials: Array<SupplementalMaterialResponse>;
    /**
     * 
     * @type {Array<LanguageMaterialResponse>}
     * @memberof ApplicationResponse
     */
    languageEnMaterials: Array<LanguageMaterialResponse>;
    /**
     * 
     * @type {Array<LanguageMaterialResponse>}
     * @memberof ApplicationResponse
     */
    languageJaMaterials: Array<LanguageMaterialResponse>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof ApplicationResponse
     */
    additionalEvidences: Array<Attachment>;
    /**
     * 
     * @type {Array<EmploymentHistoryResponse>}
     * @memberof ApplicationResponse
     */
    employmentHistories: Array<EmploymentHistoryResponse>;
    /**
     * 
     * @type {Array<ApplicationQuestionResponse>}
     * @memberof ApplicationResponse
     */
    applicationQuestions: Array<ApplicationQuestionResponse>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof ApplicationResponse
     */
    recommendationLetters: Array<Attachment>;
    /**
     * 
     * @type {Attachment}
     * @memberof ApplicationResponse
     */
    photo?: Attachment;
    /**
     * 
     * @type {Attachment}
     * @memberof ApplicationResponse
     */
    statementOfPurpose?: Attachment;
    /**
     * 
     * @type {Attachment}
     * @memberof ApplicationResponse
     */
    gpaCertificate?: Attachment;
    /**
     * 
     * @type {Attachment}
     * @memberof ApplicationResponse
     */
    gpaCalculationDocument?: Attachment;
    /**
     * 
     * @type {Attachment}
     * @memberof ApplicationResponse
     */
    englishCertificateFromUniversity?: Attachment;
    /**
     * 
     * @type {Attachment}
     * @memberof ApplicationResponse
     */
    englishCertificateFromOther?: Attachment;
    /**
     * 
     * @type {Option}
     * @memberof ApplicationResponse
     */
    program?: Option;
    /**
     * 
     * @type {Option}
     * @memberof ApplicationResponse
     */
    course?: Option;
    /**
     * 
     * @type {Option}
     * @memberof ApplicationResponse
     */
    nationality?: Option;
    /**
     * 
     * @type {Option}
     * @memberof ApplicationResponse
     */
    secondNationality?: Option;
    /**
     * 
     * @type {Option}
     * @memberof ApplicationResponse
     */
    financialSupport?: Option;
    /**
     * 
     * @type {ScreenTypeOption}
     * @memberof ApplicationResponse
     */
    screenTypeEnOption?: ScreenTypeOption;
    /**
     * 
     * @type {ScreenTypeOption}
     * @memberof ApplicationResponse
     */
    screenTypeJaOption?: ScreenTypeOption;
}

/**
* @export
* @enum {string}
*/
export enum ApplicationResponseStateEnum {
    Draft = 'Draft',
    Sent = 'Sent',
    Reviewing = 'Reviewing',
    ApproveRequested = 'ApproveRequested',
    ApproveCanceled = 'ApproveCanceled',
    ApproveAccepted = 'ApproveAccepted',
    ApproveRejected = 'ApproveRejected',
    RelayRequested = 'RelayRequested',
    RelayCanceled = 'RelayCanceled',
    RelayTeacherRequested = 'RelayTeacherRequested',
    RelayTeacherCanceled = 'RelayTeacherCanceled',
    RelayTeacherAccepted = 'RelayTeacherAccepted',
    RelayTeacherRejected = 'RelayTeacherRejected',
    RelayAccepted = 'RelayAccepted',
    RelayRejected = 'RelayRejected',
    Direct = 'Direct',
    CanceledReentryAllowed = 'CanceledReentryAllowed',
    Canceled = 'Canceled',
    Accepted = 'Accepted',
    RejectedReentryAllowed = 'RejectedReentryAllowed',
    Rejected = 'Rejected',
    Old = 'Old'
}/**
* @export
* @enum {string}
*/
export enum ApplicationResponseGenderEnum {
    Male = 'Male',
    Female = 'Female'
}/**
* @export
* @enum {string}
*/
export enum ApplicationResponseProgramPreferredLanguageEnum {
    Ja = 'Ja',
    En = 'En'
}/**
* @export
* @enum {string}
*/
export enum ApplicationResponseLanguageEnum {
    Ja = 'Ja',
    En = 'En'
}

export function ApplicationResponseFromJSON(json: any): ApplicationResponse {
    return ApplicationResponseFromJSONTyped(json, false);
}

export function ApplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'applicantId': json['applicantId'],
        'binderId': json['binderId'],
        'state': json['state'],
        'reentry': json['reentry'],
        'resubmit': json['resubmit'],
        'duplicated': !exists(json, 'duplicated') ? undefined : json['duplicated'],
        'sentAt': !exists(json, 'sentAt') ? undefined : (new Date(json['sentAt'])),
        'firstSentAt': !exists(json, 'firstSentAt') ? undefined : (new Date(json['firstSentAt'])),
        'repliedAt': !exists(json, 'repliedAt') ? undefined : (new Date(json['repliedAt'])),
        'aaoNote': !exists(json, 'aaoNote') ? undefined : json['aaoNote'],
        'idCardNumber': !exists(json, 'idCardNumber') ? undefined : json['idCardNumber'],
        'readManual': !exists(json, 'readManual') ? undefined : json['readManual'],
        'familyName': !exists(json, 'familyName') ? undefined : json['familyName'],
        'middleName': !exists(json, 'middleName') ? undefined : json['middleName'],
        'givenName': !exists(json, 'givenName') ? undefined : json['givenName'],
        'familyNameInChinese': !exists(json, 'familyNameInChinese') ? undefined : json['familyNameInChinese'],
        'middleNameInChinese': !exists(json, 'middleNameInChinese') ? undefined : json['middleNameInChinese'],
        'givenNameInChinese': !exists(json, 'givenNameInChinese') ? undefined : json['givenNameInChinese'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'birthdate': !exists(json, 'birthdate') ? undefined : (new Date(json['birthdate'])),
        'otherNationality': !exists(json, 'otherNationality') ? undefined : json['otherNationality'],
        'primaryPhoneNumber': !exists(json, 'primaryPhoneNumber') ? undefined : json['primaryPhoneNumber'],
        'secondaryPhoneNumber': !exists(json, 'secondaryPhoneNumber') ? undefined : json['secondaryPhoneNumber'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'currentAddress': !exists(json, 'currentAddress') ? undefined : json['currentAddress'],
        'currentStatus': !exists(json, 'currentStatus') ? undefined : json['currentStatus'],
        'supervisor': !exists(json, 'supervisor') ? undefined : json['supervisor'],
        'researchTopic': !exists(json, 'researchTopic') ? undefined : json['researchTopic'],
        'gpa1': !exists(json, 'gpa1') ? undefined : json['gpa1'],
        'gpa2': !exists(json, 'gpa2') ? undefined : json['gpa2'],
        'otherProgram': !exists(json, 'otherProgram') ? undefined : json['otherProgram'],
        'programPreferredLanguage': !exists(json, 'programPreferredLanguage') ? undefined : json['programPreferredLanguage'],
        'screenTypeEnOther': !exists(json, 'screenTypeEnOther') ? undefined : json['screenTypeEnOther'],
        'screenTypeJaOther': !exists(json, 'screenTypeJaOther') ? undefined : json['screenTypeJaOther'],
        'japaneseHaveStudied': !exists(json, 'japaneseHaveStudied') ? undefined : json['japaneseHaveStudied'],
        'haveWorkedFullTime': !exists(json, 'haveWorkedFullTime') ? undefined : json['haveWorkedFullTime'],
        'japaneseStudyFrom': !exists(json, 'japaneseStudyFrom') ? undefined : (new Date(json['japaneseStudyFrom'])),
        'japaneseStudyTo': !exists(json, 'japaneseStudyTo') ? undefined : (new Date(json['japaneseStudyTo'])),
        'japaneseStudyMethod': !exists(json, 'japaneseStudyMethod') ? undefined : json['japaneseStudyMethod'],
        'anticipatedEnrollmentDate': !exists(json, 'anticipatedEnrollmentDate') ? undefined : (new Date(json['anticipatedEnrollmentDate'])),
        'anticipatedEnrollmentYear': !exists(json, 'anticipatedEnrollmentYear') ? undefined : json['anticipatedEnrollmentYear'],
        'anticipatedEnrollmentDateOfMonth': !exists(json, 'anticipatedEnrollmentDateOfMonth') ? undefined : json['anticipatedEnrollmentDateOfMonth'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'isAgreePrivacyNotice': !exists(json, 'isAgreePrivacyNotice') ? undefined : json['isAgreePrivacyNotice'],
        'version': json['version'],
        'createdAt': (new Date(json['createdAt'])),
        'acceptResponse': !exists(json, 'acceptResponse') ? undefined : ResponseToApplicantFromJSON(json['acceptResponse']),
        'returnResponse': !exists(json, 'returnResponse') ? undefined : ResponseToApplicantFromJSON(json['returnResponse']),
        'educations': ((json['educations'] as Array<any>).map(EducationResponseFromJSON)),
        'scholarships': ((json['scholarships'] as Array<any>).map(ScholarshipResponseFromJSON)),
        'supplementalMaterials': ((json['supplementalMaterials'] as Array<any>).map(SupplementalMaterialResponseFromJSON)),
        'languageEnMaterials': ((json['languageEnMaterials'] as Array<any>).map(LanguageMaterialResponseFromJSON)),
        'languageJaMaterials': ((json['languageJaMaterials'] as Array<any>).map(LanguageMaterialResponseFromJSON)),
        'additionalEvidences': ((json['additionalEvidences'] as Array<any>).map(AttachmentFromJSON)),
        'employmentHistories': ((json['employmentHistories'] as Array<any>).map(EmploymentHistoryResponseFromJSON)),
        'applicationQuestions': ((json['applicationQuestions'] as Array<any>).map(ApplicationQuestionResponseFromJSON)),
        'recommendationLetters': ((json['recommendationLetters'] as Array<any>).map(AttachmentFromJSON)),
        'photo': !exists(json, 'photo') ? undefined : AttachmentFromJSON(json['photo']),
        'statementOfPurpose': !exists(json, 'statementOfPurpose') ? undefined : AttachmentFromJSON(json['statementOfPurpose']),
        'gpaCertificate': !exists(json, 'gpaCertificate') ? undefined : AttachmentFromJSON(json['gpaCertificate']),
        'gpaCalculationDocument': !exists(json, 'gpaCalculationDocument') ? undefined : AttachmentFromJSON(json['gpaCalculationDocument']),
        'englishCertificateFromUniversity': !exists(json, 'englishCertificateFromUniversity') ? undefined : AttachmentFromJSON(json['englishCertificateFromUniversity']),
        'englishCertificateFromOther': !exists(json, 'englishCertificateFromOther') ? undefined : AttachmentFromJSON(json['englishCertificateFromOther']),
        'program': !exists(json, 'program') ? undefined : OptionFromJSON(json['program']),
        'course': !exists(json, 'course') ? undefined : OptionFromJSON(json['course']),
        'nationality': !exists(json, 'nationality') ? undefined : OptionFromJSON(json['nationality']),
        'secondNationality': !exists(json, 'secondNationality') ? undefined : OptionFromJSON(json['secondNationality']),
        'financialSupport': !exists(json, 'financialSupport') ? undefined : OptionFromJSON(json['financialSupport']),
        'screenTypeEnOption': !exists(json, 'screenTypeEnOption') ? undefined : ScreenTypeOptionFromJSON(json['screenTypeEnOption']),
        'screenTypeJaOption': !exists(json, 'screenTypeJaOption') ? undefined : ScreenTypeOptionFromJSON(json['screenTypeJaOption']),
    };
}

export function ApplicationResponseToJSON(value?: ApplicationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'applicantId': value.applicantId,
        'binderId': value.binderId,
        'state': value.state,
        'reentry': value.reentry,
        'resubmit': value.resubmit,
        'duplicated': value.duplicated,
        'sentAt': value.sentAt === undefined ? undefined : (value.sentAt.toISOString()),
        'firstSentAt': value.firstSentAt === undefined ? undefined : (value.firstSentAt.toISOString()),
        'repliedAt': value.repliedAt === undefined ? undefined : (value.repliedAt.toISOString()),
        'aaoNote': value.aaoNote,
        'idCardNumber': value.idCardNumber,
        'readManual': value.readManual,
        'familyName': value.familyName,
        'middleName': value.middleName,
        'givenName': value.givenName,
        'familyNameInChinese': value.familyNameInChinese,
        'middleNameInChinese': value.middleNameInChinese,
        'givenNameInChinese': value.givenNameInChinese,
        'gender': value.gender,
        'birthdate': value.birthdate === undefined ? undefined : (value.birthdate.toISOString()),
        'otherNationality': value.otherNationality,
        'primaryPhoneNumber': value.primaryPhoneNumber,
        'secondaryPhoneNumber': value.secondaryPhoneNumber,
        'postalCode': value.postalCode,
        'currentAddress': value.currentAddress,
        'currentStatus': value.currentStatus,
        'supervisor': value.supervisor,
        'researchTopic': value.researchTopic,
        'gpa1': value.gpa1,
        'gpa2': value.gpa2,
        'otherProgram': value.otherProgram,
        'programPreferredLanguage': value.programPreferredLanguage,
        'screenTypeEnOther': value.screenTypeEnOther,
        'screenTypeJaOther': value.screenTypeJaOther,
        'japaneseHaveStudied': value.japaneseHaveStudied,
        'haveWorkedFullTime': value.haveWorkedFullTime,
        'japaneseStudyFrom': value.japaneseStudyFrom === undefined ? undefined : (value.japaneseStudyFrom.toISOString()),
        'japaneseStudyTo': value.japaneseStudyTo === undefined ? undefined : (value.japaneseStudyTo.toISOString()),
        'japaneseStudyMethod': value.japaneseStudyMethod,
        'anticipatedEnrollmentDate': value.anticipatedEnrollmentDate === undefined ? undefined : (value.anticipatedEnrollmentDate.toISOString()),
        'anticipatedEnrollmentYear': value.anticipatedEnrollmentYear,
        'anticipatedEnrollmentDateOfMonth': value.anticipatedEnrollmentDateOfMonth,
        'language': value.language,
        'notes': value.notes,
        'isAgreePrivacyNotice': value.isAgreePrivacyNotice,
        'version': value.version,
        'createdAt': (value.createdAt.toISOString()),
        'acceptResponse': ResponseToApplicantToJSON(value.acceptResponse),
        'returnResponse': ResponseToApplicantToJSON(value.returnResponse),
        'educations': ((value.educations as Array<any>).map(EducationResponseToJSON)),
        'scholarships': ((value.scholarships as Array<any>).map(ScholarshipResponseToJSON)),
        'supplementalMaterials': ((value.supplementalMaterials as Array<any>).map(SupplementalMaterialResponseToJSON)),
        'languageEnMaterials': ((value.languageEnMaterials as Array<any>).map(LanguageMaterialResponseToJSON)),
        'languageJaMaterials': ((value.languageJaMaterials as Array<any>).map(LanguageMaterialResponseToJSON)),
        'additionalEvidences': ((value.additionalEvidences as Array<any>).map(AttachmentToJSON)),
        'employmentHistories': ((value.employmentHistories as Array<any>).map(EmploymentHistoryResponseToJSON)),
        'applicationQuestions': ((value.applicationQuestions as Array<any>).map(ApplicationQuestionResponseToJSON)),
        'recommendationLetters': ((value.recommendationLetters as Array<any>).map(AttachmentToJSON)),
        'photo': AttachmentToJSON(value.photo),
        'statementOfPurpose': AttachmentToJSON(value.statementOfPurpose),
        'gpaCertificate': AttachmentToJSON(value.gpaCertificate),
        'gpaCalculationDocument': AttachmentToJSON(value.gpaCalculationDocument),
        'englishCertificateFromUniversity': AttachmentToJSON(value.englishCertificateFromUniversity),
        'englishCertificateFromOther': AttachmentToJSON(value.englishCertificateFromOther),
        'program': OptionToJSON(value.program),
        'course': OptionToJSON(value.course),
        'nationality': OptionToJSON(value.nationality),
        'secondNationality': OptionToJSON(value.secondNationality),
        'financialSupport': OptionToJSON(value.financialSupport),
        'screenTypeEnOption': ScreenTypeOptionToJSON(value.screenTypeEnOption),
        'screenTypeJaOption': ScreenTypeOptionToJSON(value.screenTypeJaOption),
    };
}


